<template>
<div class="container-fluid d-flex flex-column">
  <div class="bible-open-head">
  </div>
  <div class="row no-gutters bible-open-body">
    <app-bible-tool-profile />
  </div>
</div>
</template>

<script>
import AppBibleToolProfile from '@/components/AppBibleToolProfile.vue'

export default {
  components: {
    AppBibleToolProfile,
  },
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      errors: {
      },
    }
  },
  computed: {
  },
  methods: {
    signin (event) {
      event.preventDefault()
      this.errors = {}
      this.$store.dispatch('authSignin', this.form).then(() => {
      }).catch((error) => {
        this.errors = error.response.data.errors
      })
    },
    forgetPassword (event) {
      event.preventDefault()
      this.errors = {}
      this.$store.dispatch('authForgetPassword', this.form).then(() => {
      }).catch((error) => {
        this.errors = error.response.data.errors
      })
    },
  },
  created: function() {
  },
  async mounted () {
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (collapseId.match(/auth-accordion-*/)) {
        this.form = {}
        this.errors = {}
      }
    })
  },
  beforeDestroy: function () {
  }
}
</script>

<style lang="scss">
</style>
